<template>
  <merchandise-detail :is-create="false"></merchandise-detail>
</template>

<script>
import MerchandiseDetail from '../components/EditMerchandiseDetail'
export default {
  name: 'EditMerchandise',
  components: {
    MerchandiseDetail
  }
}
</script>
